import { firebaseApp } from './firebase'

/* Login without a password through Firebase Authentication. Firebase only
   proves who someone is: we send its ID token to the API once
   (POST /api/me/login) and from then on use our own profile token, so the
   Firebase session is signed out right away. firebase/auth is loaded only
   when someone logs in. */
async function load() {
  const auth = await import('firebase/auth')
  return { auth, instance: auth.getAuth(firebaseApp()) }
}

async function idTokenOnce({ auth, instance }, credential) {
  const token = await credential.user.getIdToken()
  auth.signOut(instance).catch(() => {})
  return token
}

/* "Nastavi s Google": a Google popup; resolves to a Firebase ID token. */
export async function googleIdToken() {
  const firebase = await load()
  const provider = new firebase.auth.GoogleAuthProvider()
  provider.setCustomParameters({ prompt: 'select_account' })
  const credential = await firebase.auth.signInWithPopup(firebase.instance, provider)
  return idTokenOnce(firebase, credential)
}

/* "Nastavi s emailom": Firebase emails a link back to /prijava. */
export async function sendEmailLink(email) {
  const { auth, instance } = await load()
  await auth.sendSignInLinkToEmail(instance, email, {
    url: `${window.location.origin}/prijava`,
    handleCodeInApp: true,
  })
}

export async function isEmailLink(href) {
  const { auth, instance } = await load()
  return auth.isSignInWithEmailLink(instance, href)
}

/* The link was opened: resolves to a Firebase ID token. */
export async function emailLinkIdToken(email, href) {
  const firebase = await load()
  const credential = await firebase.auth.signInWithEmailLink(firebase.instance, email, href)
  return idTokenOnce(firebase, credential)
}

/* Firebase error codes worth telling apart in the UI. */
export function loginErrorKind(error) {
  const code = error?.code || ''
  if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') return 'cancelled'
  if (code === 'auth/popup-blocked') return 'popup'
  if (code === 'auth/invalid-email') return 'email'
  if (code === 'auth/invalid-action-code' || code === 'auth/expired-action-code') return 'expired'
  if (code === 'auth/quota-exceeded') return 'quota'
  return 'other'
}
